export default "__VITE_ASSET__BwYFB3hN__"